import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from 'app/core/services/auth.service';
import {AppUrls} from 'app/core/url/app-urls.service';

@Injectable({
    providedIn: 'root',
})
export class OnboardingGuard {
    constructor(
        private auth: AuthService,
        private router: Router
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (this.auth.getCurrentUserLastValue()?.onboardingShowCreateApp) {
            this.router.navigateByUrl(AppUrls.ONBOARDING_APP);
            return false;
        }

        return true;
    }
}
